import fightingIcon from "../../../img/welcome-carusel/fighting.png";
import gymsIcon from "../../../img/welcome-carusel/gyms.png";
import pilatisIcon from "../../../img/welcome-carusel/pilatis.png";
import runningIcon from "../../../img/welcome-carusel/running.png";
import swimmingIcon from "../../../img/welcome-carusel/swimming.png";
import tubIcon from "../../../img/welcome-carusel/tub.png";
import yogaIcon from "../../../img/welcome-carusel/yoga.png";

// Activity categories shown in the welcome carousel. Static by design — this is
// marketing copy, not the live club-category list from appParamSlice.
// `key` is the React key and the icon's file stem; `labelKey` is the i18n key.
export const WELCOME_CATEGORIES = [
  { key: "gyms", labelKey: "WELCOME_CAT_GYMS", icon: gymsIcon },
  { key: "pilatis", labelKey: "WELCOME_CAT_PILATIS", icon: pilatisIcon },
  { key: "fighting", labelKey: "WELCOME_CAT_FIGHTING", icon: fightingIcon },
  { key: "yoga", labelKey: "WELCOME_CAT_YOGA", icon: yogaIcon },
  { key: "running", labelKey: "WELCOME_CAT_RUNNING", icon: runningIcon },
  { key: "swimming", labelKey: "WELCOME_CAT_SWIMMING", icon: swimmingIcon },
  { key: "tub", labelKey: "WELCOME_CAT_TUB", icon: tubIcon },
];
